module.exports = "/_next/static/images/13a3cdc34db92d200628cb3180f80f6d-mgm-invite-ticket-1.jpg";